/**
 * This class initiates the polyfills required for the website.
 * 
 * @export
 * @class PolyFills
 */
import 'array-from-polyfill';
import 'element-closest-polyfill';
import 'es6-object-assign/auto';
import 'formdata-polyfill';
import 'intersection-observer';
import 'jspolyfill-array.prototype.find';
import 'polyfill-array-includes';
import 'promise-polyfill/src/polyfill';
import 'url-search-params-polyfill';


// @ts-ignore
import * as objectFitImages from 'object-fit-images'; // tslint:disable-line
// @ts-ignore
import * as objectFitVideos from 'object-fit-videos';

export class PolyFills {

    constructor() {
        objectFitImages();
        objectFitVideos();
    }
}
